<template>
    <div
        v-if="open"
        ref="dialog"
        class="confirm-overlay flex items-center justify-center p-3"
        role="alertdialog"
        aria-modal="true"
        :aria-labelledby="`${id}-title`"
        :aria-describedby="`${id}-message`"
        tabindex="-1"
        @click.self="cancel"
        @keydown.esc.prevent="cancel"
    >
        <div class="confirm-dialog w-full" role="document">
            <div class="confirm-header px-4 py-3">
                <h3 :id="`${id}-title`" class="mb-0">{{ title }}</h3>
            </div>
            <div class="confirm-body p-4">
                <p :id="`${id}-message`" class="mb-0 text-sm text-pip-gray">{{ message }}</p>
            </div>
            <div class="confirm-actions flex items-center justify-end gap-2 px-4 py-3">
                <button ref="cancel" type="button" class="btn btn-sm btn-secondary" :disabled="working" @click="cancel">
                    Cancel
                </button>
                <button type="button" class="btn btn-sm btn-danger" :disabled="working" @click="$emit('confirm')">
                    {{ working ? workingLabel : confirmLabel }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AdminConfirmDialog",
    props: {
        id: { type: String, required: true },
        open: { type: Boolean, default: false },
        title: { type: String, required: true },
        message: { type: String, required: true },
        confirmLabel: { type: String, default: "Confirm" },
        workingLabel: { type: String, default: "Working…" },
        working: { type: Boolean, default: false },
    },
    watch: {
        open(isOpen) {
            if (!isOpen) return;
            this.$nextTick(() => {
                if (this.$refs.cancel) this.$refs.cancel.focus();
            });
        },
    },
    methods: {
        cancel() {
            if (!this.working) this.$emit("cancel");
        },
    },
};
</script>

<style scoped lang="scss">
.confirm-overlay {
    position: fixed;
    z-index: 1060;
    inset: 0;
    background: rgba(17, 17, 17, 0.58);
}

.confirm-dialog {
    max-width: 28rem;
    overflow: hidden;
    border: 1px solid var(--color-light-grey);
    border-radius: 6px;
    background: #fff;
    box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.25);
}

.confirm-header {
    border-bottom: 1px solid var(--color-light-grey);
    background: var(--color-gallery);
}

.confirm-header h3 {
    color: var(--color-mine-shaft);
    font-size: var(--font-size-lg);
}

.confirm-actions {
    border-top: 1px solid var(--color-light-grey);
    background: #f8f8f8;
}
</style>
